import { getTeamLogoUrl } from "@/lib/logo-resolver";
import { getHungarianWorldCupTeamName } from "@/lib/world-cup-team-names";

type FavoriteTeamMarkTeam = {
  name: string;
  logoUrl: string | null;
  externalTeam?: { crest: string | null } | null;
};

export function FavoriteTeamMark({ team }: { team?: FavoriteTeamMarkTeam | null }) {
  if (!team) return null;
  const teamName = getHungarianWorldCupTeamName(team.name) || team.name;

  return (
    <span
      className="inline-flex max-w-full shrink-0 items-center gap-1.5 rounded-full bg-[#EEF0EA] px-2 py-0.5 align-middle text-[10px] font-black leading-4 text-[#273E47]"
      title={`Kedvenc csapat: ${teamName}`}
      aria-label={`Kedvenc csapat: ${teamName}`}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={getTeamLogoUrl(team)} alt="" className="h-4 w-4 object-contain" loading="lazy" decoding="async" />
      <span className="truncate">{teamName}</span>
    </span>
  );
}
